export function hostnameWithoutSubdomain(hostname: string | undefined): string {
	return hostname?.split('.').slice(-2).join('.') ?? '';
}
